import { Box, Button, Divider, Heading, Icon, Text } from '@medely/ui-kit';
import { ContentLoader, JobDetailsListItem } from '@mp/components';
import { debounce } from 'lodash';
import React, { useMemo, useState } from 'react';
import { usePhoneScreeningScheduledData } from './usePhoneScreeningScheduledData';
import { useApplicationMutations } from '../../applicationFlowMutations';

const RESCHEDULE_DEBOUNCE_DELAY = 1000;

export const PhoneScreeningScheduled = () => {
  const { isLoading, date, time, recruiterMessage, cancelScreening, isMutationPending } =
    usePhoneScreeningScheduledData();

  const { prevStep } = useApplicationMutations();
  const [isRescheduling, setIsRescheduling] = useState(false);

  const debouncedReschedule = useMemo(() => {
    const handleReschedule = () => {
      if (isRescheduling || isMutationPending) {
        return;
      }

      setIsRescheduling(true);
      cancelScreening();
      prevStep();

      setTimeout(() => {
        setIsRescheduling(false);
      }, RESCHEDULE_DEBOUNCE_DELAY);
    };

    return debounce(handleReschedule, RESCHEDULE_DEBOUNCE_DELAY, {
      leading: true,
      trailing: false,
    });
  }, [isRescheduling, isMutationPending, cancelScreening, prevStep]);

  const isButtonDisabled = isRescheduling || isMutationPending;

  return (
    <ContentLoader loading={isLoading}>
      <>
        <Box mb={2}>
          <Heading size="m" color="text.primary">
            Your interview is confirmed
          </Heading>
        </Box>
        <Divider />
        <Box py={2}>
          <JobDetailsListItem
            icon={
              <Icon name="light-calendar" iconSize="20px" color="text.primary" variant="custom" />
            }
            title="Date"
          >
            <Text size="m">{date}</Text>
          </JobDetailsListItem>
        </Box>
        <Box py={2}>
          <JobDetailsListItem
            icon={<Icon name="light-clock" iconSize="20px" color="text.primary" variant="custom" />}
            title="Time"
          >
            <Text size="m">{time}</Text>
          </JobDetailsListItem>
        </Box>
        <Box py={2}>
          <JobDetailsListItem
            icon={<Icon name="user-search" iconSize="20px" color="text.primary" variant="custom" />}
            title="Your clinical specialist"
          >
            <Text size="m">{recruiterMessage}</Text>
          </JobDetailsListItem>
        </Box>
        <Divider />
        <Box py={2} alignSelf="flex-end">
          <Button
            variant="contained"
            color="primary"
            onClick={debouncedReschedule}
            loading={isButtonDisabled}
            disabled={isButtonDisabled}
          >
            Reschedule
          </Button>
        </Box>
      </>
    </ContentLoader>
  );
};
